export default {
  firstDay: 0,
  showLimit: 3,
  locale: 'en',
  fullDayNames: false,
  fullMonthNames: false,
  class: 'vue-calendar',
  componentName: 'vue-calendar',
}
